import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";

const initialState = {};

const middleware = [thunk];

const reduxDevTools =
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

let storeComposer;

if (process.env.NODE_ENV === "production" || !reduxDevTools) {
  storeComposer = compose(applyMiddleware(...middleware));
} else {
  storeComposer = compose(applyMiddleware(...middleware), reduxDevTools);
}

const store = createStore(rootReducer, initialState, storeComposer);

export default store;
